import { Dialog } from 'primereact/dialog';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { createPortal } from 'react-dom';
import FirstPageUI from './FirstPageUI';
import SecondPageUI from './SecondPageUI';
import ThirdPageUI from './ThirdPageUI';
import { Button } from 'primereact/button';
import { ArrowLeft, ArrowRight, X } from 'lucide-react';

export enum optionModal {
  FIRST,
  SECOND,
  THIRD,
}

interface Props {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  option: optionModal;
  setOption: Dispatch<SetStateAction<optionModal>>;
}

const StudentLearnExperienceModal: FC<Props> = ({ visible, setVisible, option, setOption }) => {
  const [expandedImage, setExpandedImage] = useState<string | null>(null);

  const footer = (
    <div
      className={`tw-flex tw-flex-row tw-mt-2 ${option === optionModal.FIRST ? 'tw-ml-auto' : ''} ${
        option === optionModal.SECOND ? 'tw-justify-between tw-w-full' : ''
      } ${option === optionModal.THIRD ? 'tw-mr-auto' : ''}`}
    >
      {option !== optionModal.FIRST && (
        <Button
          outlined
          label={option === optionModal.SECOND ? 'The personalized path' : "What's a skill?"}
          icon={<ArrowLeft size={20} />}
          className="tw-flex tw-gap-x-2"
          onClick={() => (option === optionModal.SECOND ? setOption(optionModal.FIRST) : setOption(optionModal.SECOND))}
        />
      )}
      {option !== optionModal.THIRD && (
        <Button
          label={option === optionModal.FIRST ? "Next: What's a skill?" : 'Next: The skill cycle'}
          icon={<ArrowRight size={20} />}
          className="tw-flex tw-flex-row-reverse tw-gap-x-2"
          onClick={() => (option === optionModal.FIRST ? setOption(optionModal.SECOND) : setOption(optionModal.THIRD))}
        />
      )}
    </div>
  );

  const header = (
    <div className="tw-flex tw-flex-row tw-mr-auto tw-gap-x-2 tw-items-center">
      <span
        className={`tw-text-sm tw-font-sora tw-font-bold tw-text-white tw-rounded-lg tw-p-2 tw-leading-none ${
          option === optionModal.FIRST ? 'tw-bg-indigo-700' : ''
        } ${option === optionModal.SECOND ? 'tw-bg-purple-700' : ''} ${
          option === optionModal.THIRD ? 'tw-bg-sky-700' : ''
        } `}
      >
        {option === optionModal.FIRST && 'A'}
        {option === optionModal.SECOND && 'B'}
        {option === optionModal.THIRD && 'C'}
      </span>
      <h1
        className={`tw-text-lg tw-font-sora tw-font-bold ${option === optionModal.FIRST ? 'tw-text-indigo-700' : ''} ${
          option === optionModal.SECOND ? 'tw-text-purple-700' : ''
        } ${option === optionModal.THIRD ? 'tw-text-sky-700' : ''} `}
      >
        {option === optionModal.FIRST && 'The Roadmap'}
        {option === optionModal.SECOND && 'Skills'}
        {option === optionModal.THIRD && 'The skill cycle'}
      </h1>
    </div>
  );

  return (
    <>
      <Dialog
        className={`tw-w-[75%] ${expandedImage ? 'tw-invisible' : ''}`}
        maskClassName={expandedImage ? 'tw-invisible' : ''}
        onHide={() => setVisible(false)}
        visible={visible}
        footer={footer}
        header={header}
        pt={{ content: { className: '!tw-p-0' } }}
      >
        <div className={`${option === optionModal.THIRD ? 'tw-px-16' : 'tw-px-20'} tw-py-5`}>
          {option === optionModal.FIRST && <FirstPageUI />}
          {option === optionModal.SECOND && <SecondPageUI />}
          {option === optionModal.THIRD && <ThirdPageUI onExpandImage={setExpandedImage} />}
        </div>
      </Dialog>

      {expandedImage &&
        createPortal(
          <div
            className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black/90 tw-p-8"
            style={{ zIndex: 100000 }}
            onClick={() => setExpandedImage(null)}
          >
            <button
              type="button"
              aria-label="Close preview"
              onClick={() => setExpandedImage(null)}
              className="tw-absolute tw-right-6 tw-top-6 tw-flex tw-h-10 tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-white/10 tw-text-white hover:tw-bg-white/20"
            >
              <X size={24} />
            </button>
            <img
              src={expandedImage}
              alt="Expanded screenshot"
              className="tw-max-h-[90vh] tw-max-w-[90vw] tw-rounded-lg tw-object-contain tw-shadow-2xl"
              onClick={e => e.stopPropagation()}
            />
          </div>,
          document.body,
        )}
    </>
  );
};

export default StudentLearnExperienceModal;
